<template>
	<div>
		<v-container>
			<v-breadcrumbs :items="breadcrumbs">
				<template #divider>
					<v-icon>mdi-chevron-left</v-icon>
				</template>
			</v-breadcrumbs>

			<v-row class="full-width" justify="center">
				<v-col cols="12" md="5">
					<v-row justify="center">
						<v-col class="text-center text-subtitle-1" cols="6">
							<h5>
								<b>اسم المجموعة</b>
							</h5>
							<h5 v-if="userGroup" class="grey--text">{{ userGroup.name }}</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>

						<v-col class="text-center text-subtitle-1" cols="6">
							<h5>
								<b>المجموعة الأب</b>
							</h5>
							<h5 v-if="userGroup">
								<router-link :to="'/users/grouppage/' + userGroup.parentID" class="primary--text">{{ userGroup.parentID }}</router-link>
							</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>
					</v-row>

					<v-row justify="center">
						<v-col class="text-center" cols="6">
							<h5>
								<b>وصف المجموعة</b>
							</h5>
							<h5 v-if="userGroup" class="grey--text">{{ userGroup.description }}</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>

						<v-col class="text-center" cols="6">
</v-col>
					</v-row>
				</v-col>
				<v-divider v-if="$vuetify.breakpoint.mdAndUp" vertical></v-divider>
				<v-col cols="12" md="5">
					<v-row justify="center">
						<v-col class="text-center text-subtitle-1" cols="6">
							<h5>
								<b>عدد الأعضاء</b>
							</h5>
							<h5 v-if="userGroup" class="grey--text">{{ totalUsers }}</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>

						<v-col class="text-center text-subtitle-1" cols="6">
							<h5>
								<b>عدد المشرفين</b>
							</h5>
							<h5 v-if="userGroup" class="grey--text">{{ admins.length }}</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>

						<v-col class="text-center text-subtitle-1" cols="6">
							<h5>
								<b>عدد المجموعات الفرعية</b>
							</h5>
							<h5 v-if="userGroup" class="grey--text">{{ totalSubGroups }}</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>

						<v-col class="text-center text-subtitle-1" cols="6">
							<h5>
								<b>عدد الصلاحيات المفعلة</b>
							</h5>
							<h5 v-if="userGroup" class="grey--text">
								{{ numberOfPrivs }}
								صلاحية
								<br />
								من
								{{ numberOfPrivGroups }}
								اقسام
							</h5>
							<h5 v-else class="white--text">-</h5>
						</v-col>
					</v-row>
				</v-col>
			</v-row>

			<v-row justify="center">
				<v-col cols="12">
					<v-tabs v-model="tab" centered>
						<v-tab v-for="section in sections" :key="section.name">{{ section.name }}</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab">
						<v-tab-item class="text-center">
							<v-row justify="center">
								<v-col class="text-end">
									<v-btn color="primary" :disabled="!privs.editUsers" @click="addUser">إضافة عضو للمجموعة</v-btn>
								</v-col>
								<!-- <v-col class="text-start">
									<v-btn @click=";">إزالة من المجموعة</v-btn>
								</v-col> -->
							</v-row>
							<v-data-table
								class="elevation-1"
								:headers="headers.users"
								:items="users"
								hide-default-footer
							>
								<template #[`item.avatar`]="{ item }">
									<v-avatar size="32">
										<v-img :src="item.avatar"></v-img>
									</v-avatar>
								</template>
							</v-data-table>
							<div class="text-center pt-2">
								<v-pagination v-model="usersPage" :length="pageCountUsers"></v-pagination>
							</div>
						</v-tab-item>
						<v-tab-item class="text-center">
							<v-row justify="center">
								<v-col class="text-end">
									<v-btn color="primary" :disabled="!privs.editAdmins" @click="addAdmin">تعيين مشرف</v-btn>
								</v-col>
							</v-row>
							<v-data-table
								class="elevation-1"
								:headers="headers.admins"
								:items="admins"
								hide-default-footer
							>
								<template #[`item.avatar`]="{ item }">
									<v-avatar size="32">
										<v-img :src="item.avatar"></v-img>
									</v-avatar>
								</template>

								<template #[`item.superAdmin`]="{ item }">
									<v-icon v-if="item.superAdmin">mdi-check</v-icon>
								</template>

								<template #[`item.actions`]="{ item }">
									<v-tooltip bottom>
										<template #activator="{ on }">
											<v-btn
												:disabled="loading"
												icon
												color="primary"
												v-on="on"
												@click="editAdmin(item)"
											>
												<v-icon>mdi-pencil</v-icon>
											</v-btn>
										</template>

										<span>تعديل</span>
									</v-tooltip>
									
									<v-tooltip bottom>
										<template #activator="{ on }">
											<v-btn
												:disabled="loading"
												icon
												color="primary"
												v-on="on"
												@click="confirmDeleteAdmin(item.id)"
											>
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</template>

										<span>حذف</span>
									</v-tooltip>
								</template>
							</v-data-table>
							<div class="text-center pt-2">
								<v-pagination v-model="adminsPage" :length="pageCountAdmins"></v-pagination>
							</div>
						</v-tab-item>
						<v-tab-item class="text-center">
							<v-data-table
								class="elevation-1"
								:headers="headers.subgroups"
								:items="subGroups"
								hide-default-footer
							>
							<template #[`item.name`]="{ item }">
								<router-link :to="'/users/grouppage/' + item.userGroupID" class="primary--text">{{ item.name }}</router-link>
							</template>
							</v-data-table>
							<div class="text-center pt-2">
								<v-pagination v-model="subgroupsPage" :length="pageCountSubGroups"></v-pagination>
							</div>
							<!-- <v-row justify="center">
								<v-col class="text-end">
									<v-btn @click="addGroup()">إضافة مجموعة</v-btn>
								</v-col>
								<v-col class="text-start">
									<v-btn @click=";">إزالة مجموعة</v-btn>
								</v-col>
							</v-row> -->
						</v-tab-item>
						<v-tab-item class="text-center">
							<v-data-table
								class="elevation-1"
								:headers="headers.privileges"
								:items="privileges"
								hide-default-footer
								:items-per-page="-1"
								group-by="parentID"
								item-key="privilegeID"
							>
								<template #[`item.privilegeValue`]="{ item }">
									<v-switch
										v-if="parentPrivs[item.parentID].privilegeValue"
										v-model="item.privilegeValue"
										hide-details
										class="pa-0 ma-0"
										:disabled="!privs.editPrivileges || loading"
										:loading="item.loading"
										@click="updatePrivilege(item)"
									></v-switch>
								</template>

								<template #[`group.header`]="{ group, toggle, isOpen }">
									<td class="text-start blue lighten-4">
										<v-icon v-if="isOpen" @click="toggle">mdi-minus</v-icon>
										<v-icon v-else @click="toggle">mdi-plus</v-icon>
										{{ parentPrivs[group].name }}
									</td>
									<td class="text-start blue lighten-4">{{ parentPrivs[group].description }}</td>
									<td class="blue lighten-4">
										<v-switch
											v-model="parentPrivs[group].privilegeValue"
											hide-details
											class="pa-0 ma-0"
											:disabled="!privs.editPrivileges || loading"
											:loading="parentPrivs[group].loading"
											@click="updatePrivilege(parentPrivs[group])"
										></v-switch>
									</td>
								</template>
							</v-data-table>
							<!-- <div class="text-center pt-2">
								<v-pagination v-model="privilegesPage" :length="pageCountprivileges"></v-pagination>
							</div>-->
						</v-tab-item>
					</v-tabs-items>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="addNewGroupDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مجموعة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-if="addNewGroupDialog" ref="addNewGroupForm" v-model="valid">
						<v-row dense>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field
									v-model="newGroup.groupID"
									outlined
									hide-details="auto"
									label="معرف المجموعة"
									dir="ltr"
									:rules="[rules.required, rules.id]"
								></v-text-field>
							</v-col>

							<v-col cols="12" md="6" class="py-0">
								<v-text-field
									v-model="newGroup.name"
									outlined
									hide-details="auto"
									label="اسم المجموعة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newGroup.description"
									outlined
									hide-details="auto"
									label="وصف المجموعة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="addUserDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مستخدم جديد</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form ref="addUserForm" v-model="valid2">
						<v-row dense>
							<v-col cols="12" class="py-1">
								<v-text-field
									v-model="newUser.displayName"
									outlined
									hide-details="auto"
									label="اسم العرض"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" class="py-1">
								<v-text-field
									v-model="newUser.password"
									outlined
									hide-details="auto"
									label="كلمة المرور"
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPassword ? 'text' : 'password'"
									:rules="[rules.required, rules.password]"
									@click:append="() => (showPassword = !showPassword)"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="newUser.fullName"
									outlined
									hide-details="auto"
									label="الاسم"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col>
								<v-autocomplete
									v-model="specialties"
									:items="allSpecialties"
									item-text="name"
									item-value="id"
									label="التخصص"
									outlined
									hide-details
								>
									<template #item="{ item }">
										<v-list-item-content>
											<v-list-item-title>
												{{ item.name }}
											</v-list-item-title>
											<v-list-item-subtitle v-if="item.femName" class="text-caption">
												{{ item.femName }}
											</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" class="py-1">
								<v-text-field
									v-model="newUser.email"
									outlined
									hide-details="auto"
									label="البريد الإلكتروني"
									dir="ltr"
									:rules="[rules.required, rules.email]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="py-1">
								<v-text-field
									v-model="newUser.phoneNumber"
									outlined
									hide-details="auto"
									label="رقم الجوال"
									dir="ltr"
									placeholder="+9665XXXXXXXX"
									:rules="[rules.required, rules.mobile]"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="py-1">
								<v-select
									v-model="newUser.gender"
									outlined
									hide-details="auto"
									label="الجنس"
									:items="genders"
									item-text="name"
									item-value="value"
								></v-select>
							</v-col>

							<v-col cols="12" class="py-1">
								<v-select
									v-model="newUser.stateID"
									outlined
									hide-details="auto"
									label="الحالة"
									:items="userStates"
									item-text="name"
									item-value="stateID"
									:rules="[rules.required]"
								></v-select>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="insertUser">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="addAdminDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تعيين مشرف جديد</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid3">
						<v-row dense>
							<v-col cols="12" class="py-1">
								<v-autocomplete
									v-model="newAdmin.userID"
									:items="allUsers"
									hide-details
									outlined
									item-text="fullName"
									item-value="id"
									label="المشرف"
									clearable
									:rules="[rules.required]"
								>
									<template #item="{ item }">
										<v-list-item-avatar>
											<img :src="item.avatar" />
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ item.fullName }}</v-list-item-title>
											<v-list-item-subtitle>{{ item.displayName }}</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</v-autocomplete>
							</v-col>

							<v-col cols="12" class="py-1">
								<v-switch v-model="newAdmin.superAdmin" label="مشرف مسؤول" :disabled="loading" :true-value="1" :false-value="0" hide-details class="mt-0"></v-switch>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid3" :loading="loading" @click="insertAdmin">تعيين</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="editAdminDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تعديل بيانات المشرف</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid4">
						<v-row dense>
							<v-col cols="12" class="py-1">
								<v-autocomplete
									v-model="newAdmin.userID"
									:items="allUsers"
									hide-details
									outlined
									item-text="fullName"
									item-value="id"
									label="المشرف"
									clearable
									:rules="[rules.required]"
									disabled
								>
									<template #item="{ item }">
										<v-list-item-avatar>
											<img :src="item.avatar" />
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ item.fullName }}</v-list-item-title>
											<v-list-item-subtitle>{{ item.displayName }}</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</v-autocomplete>
							</v-col>

							<v-col cols="12" class="py-1">
								<v-switch v-model="newAdmin.superAdmin" label="مشرف مسؤول" :disabled="loading" :true-value="1" :false-value="0" hide-details class="mt-0"></v-switch>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid4" :loading="loading" @click="updateAdmin">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<app-confirmation-dialog ref="confirm"></app-confirmation-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	components:{
		AppConfirmationDialog: () => import(/* webpackChunkName: "app-confirmation-dialog" */ "@/components/AppConfirmationDialog"),
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	beforeRouteUpdate(to, from, next) {
		if (to.params.groupID != from.params.groupID) {
			this.$store.dispatch("setLoading", false);
		}
		next()
	},
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'المجموعات', to: { name: 'dashboard-groups' } },
				{ text: '...', disabled: true }
			],
			
			userGroup: null,
			usersPage: 1,
			adminsPage: 1,
			subgroupsPage: 1,
			pageCountprivileges: 1,
			admins: [],
			users: [],
			subGroups: [],
			privileges: [],
			parentPrivs: {},
			tab: null,
			pageCountUsers: 1,
			pageCountAdmins: 1,
			pageCountSubGroups: 1,
			addNewGroupDialog: false,
			newGroup: {},
			headers: {
				users: [
					{
						text: "صورة العرض",
						value: "avatar",
						sortable: false
					},
					{
						text: "الاسم",
						value: "fullName",
						sortable: false
					},
					{
						text: "اسم المستخدم",
						value: "displayName",
						sortable: false
					},
					{
						text: "البريد الإلكتروني",
						value: "email",
						sortable: false
					},
					{
						text: "رقم الهاتف",
						value: "phoneNumber",
						sortable: false
					},
					{ text: "الحالة", value: "state", sortable: false }
				],
				admins: [
					{
						text: "صورة العرض",
						value: "avatar",
						sortable: false
					},
					{
						text: "الاسم",
						value: "fullName",
						sortable: false
					},
					{
						text: "اسم المستخدم",
						value: "displayName",
						sortable: false
					},
					{
						text: "البريد الإلكتروني",
						value: "email",
						sortable: false
					},
					{
						text: "رقم الهاتف",
						value: "phoneNumber",
						sortable: false
					},
					{
						text: "مشرف مسؤول",
						value: "superAdmin",
						sortable: false,
						align: "center"
					},
					{ text: "العمليات", value: "actions", sortable: false }
				],
				subgroups: [
					{ text: "اسم المجموعة", value: "name" },
					{ text: "وصف المجموعة", value: "description" },
					{ text: "حالة المجموعة", value: "state.name" },
				],
				privileges: [
					{
						text: "الصلاحية الأب",
						value: "parentID",
						groupable: true
					},
					{ text: "نوع الصلاحيات", value: "name" },
					{ text: "الوصف", value: "description" },
					{ text: "مفعل", value: "privilegeValue" }
				]
			},
			sections: [
				{ name: "الأعضاء" },
				{ name: "المشرفين" },
				{ name: "المجموعات الفرعية" },
				{ name: "الصلاحيات" }
			],
			totalUsers: 0,
			totalSubGroups: 0,
			loading: false,
			numberOfPrivs: 0,
			numberOfPrivGroups: 0,

			showPassword: false,
			newUser: {},
			valid2: false,
			userStates: [],
			genders: [
				{
					name: "-",
					value: null
				},
				{
					name: "ذكر",
					value: "M"
				},
				{
					name: "انثى",
					value: "F"
				}
			],
			addUserDialog: false,
			allUsers: [],
			newAdmin: {},
			addAdminDialog: false,
			valid3: false,
			editAdminDialog: false,
			valid4: false,
			specialties: null,
			allSpecialties: [],
		};
	},
	watch: {
		usersPage(newVal) {
			this.getUsers(newVal);
		},
		adminsPage(newVal) {
			this.getAdmins(newVal);
		},
		subgroupsPage(newVal) {
			this.getSubGroups(newVal);
		}
		// privilegesPage(newVal) {
		// 	this.getPrivileges(newVal);
		// }
	},
	mounted() {
		this.getIconsPrivileges();
		this.getUsers(1);
		this.getAdmins(1);
		this.getSubGroups(1);
		this.getPrivileges(1);
		this.getThisGroup();
		this.getUserStates();
		this.getAllUsers();
		this.getSpecialties();
	},
	methods: {
		getIconsPrivileges() {
			client
				.get("/api/privilege/groupIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getThisGroup() {
			client
				.get("/api/usergroups/show/" + this.$route.params.groupID)
				.then(response => {
					this.userGroup = response.data.data;
					this.breadcrumbs[2].text = this.userGroup.name
				})
				.catch(err => {
					console.log(err);
				});
		},
		getAllUsers() {
			client
				.get("/api/users/list")
				.then(response => {
					this.allUsers = Object.values(response.data.data);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getUsers(page) {
			this.users = [];

			client
				.get(
					"/api/usergroups/getusers/" +
						this.$route.params.groupID +
						"?page=" +
						page
				)
				.then(response => {
					this.pageCountUsers = response.data.data.last_page;
					this.users = Object.values(response.data.data.data);
					this.totalUsers = response.data.data.total;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getAdmins(page) {
			this.admins = [];
			client
				.get(
					"/api/usergroups/getGroupDirectAdmin/" +
						this.$route.params.groupID +
						"?page=" +
						page
				)
				.then(response => {
					this.pageCountAdmins = response.data.data.last_page;
					this.admins = Object.values(response.data.data.data);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getSubGroups(page) {
			client
				.post(
					"/api/usergroups/subgroup/" +
						this.$route.params.groupID +
						"?page=" +
						page
				)
				.then(response => {
					this.pageCountSubGroups = response.data.data.last_page;
					this.subGroups = Object.values(response.data.data.data);
					this.totalSubGroups = response.data.data.total;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getPrivileges(page) {
			var data = new FormData();
			data.append("userGroupID", this.$route.params.groupID);

			client
				.post("/api/usergroups/getallprivileges?page=" + page, data)
				.then(response => {
					this.pageCountprivileges = response.data.data.last_page;
					// this.privileges = Object.values(response.data.data);
					var privs = response.data.data.map(p => {
						if (p.parentID == undefined) {
							p.parentID = "ROOT";
						}
						return p;
					});
					this.privileges = privs.filter(p => p.parentID != "ROOT");

					var rootPrivs = privs
						.filter(p => p.parentID == "ROOT")
						.map(p => {
							p.loading = false;
							return p;
						});
					rootPrivs.forEach(priv => {
						this.parentPrivs[priv.privilegeID] = priv;
					});

					this.updatePrivNumbers();
				})
				.catch(err => {
					console.log(err);
				});
		},
		updatePrivilege(privilege) {
			console.log(privilege);
			if (this.loading == true) {
				return false;
			}

			this.loading = true;
			privilege.loading = true;

			let data = {
				userGroupID: this.$route.params.groupID,
				privilegeID: privilege.privilegeID,
				privilegeValue: privilege.privilegeValue
			};

			clientNotifier
				.post("/api/usergroups/updategroupprivilege", data)
				.then(response => {
					console.log(response);
					this.loading = false;
					privilege.loading = false;
					this.updatePrivNumbers();
				})
				.catch(err => {
					console.log(err);
					privilege.privilegeValue = !privilege.privilegeValue;
					this.loading = false;
					privilege.loading = false;
				});
		},
		addGroup() {
			this.newGroup = {};
			this.addNewGroupDialog = true;
			setTimeout(() => {
				this.$refs.addNewGroupForm.reset();
			}, 0);
		},
		addNewGroup() {
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			let data = new FormData();

			data.append("userGroupID", this.newGroup.groupID);
			data.append("name", this.newGroup.name);
			data.append("description", this.newGroup.description);
			data.append("stateID", this.newGroup.stateID);
			data.append("parentID", this.$route.params.groupID);

			this.loading = true;
			this.error = false;
			client
				.post("/api/usergroups/addnewgroup", data, config)
				.then(response => {
					console.log(response);
					this.newGroup.state = this.userStates.find(
						state => state.stateID == this.newGroup.stateID
					).name;
					// this.newGroup.userGroup = this.userGroups.find(
					// 	group => group.userGroupID == this.newGroup.userGroupID
					// ).name;
					this.users.push(this.newGroup);
					this.addNewGroupDialog = false;
				})
				.catch(err => {
					console.log(err);
					this.error = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updatePrivNumbers() {
			this.numberOfPrivs = this.privileges
				.filter(p => this.parentPrivs[p.parentID].privilegeValue)
				.filter(p => p.privilegeValue).length;

			this.numberOfPrivGroups = Object.values(this.parentPrivs).filter(
				p => p.privilegeValue
			).length;
		},
		getUserStates() {
			client
				.post("/api/users/getstates", {})
				.then(response => {
					console.log('userStates')
					console.log(response);
					this.userStates = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		addUser() {
			this.newUser = {};
			this.addUserDialog = true;
			setTimeout(() => {
				this.$refs.addUserForm.reset();
			}, 0);
		},
		addAdmin() {
			this.newAdmin = {};
			this.addAdminDialog = true;
		},
		editAdmin(admin) {
			this.newAdmin = {
				userID: admin.id,
				superAdmin: admin.superAdmin,
			};
			this.editAdminDialog = true;
		},
		insertUser() {
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			let data = new FormData();

			data.append("fullName", this.newUser.fullName);
			data.append("displayName", this.newUser.displayName);
			data.append("email", this.newUser.email);
			data.append("phoneNumber", this.newUser.phoneNumber);
			data.append("gender", this.newUser.gender);
			data.append("password", this.newUser.password);
			data.append("stateID", this.newUser.stateID);
			data.append("userGroupID", this.$route.params.groupID);
			data.append("specialties", this.specialties);

			this.loading = true;
			this.error = false;
			client
				.post("/api/users/addnewuser", data, config)
				.then(response => {
					console.log(response);
					this.getUsers(this.usersPage);
					this.addUserDialog = false;
					this.$store.dispatch("notify", {message: "تمت إضافة المستخدم بنجاح"});
				})
				.catch(err => {
					console.log(err);
					console.log(err.data);
					if(err.response.data.errors){
						if(err.response.data.errors.displayName && err.response.data.errors.displayName[0] == "The display name has already been taken.") {
							this.$store.dispatch("notify", {message: "اسم العرض مأخوذ مسبقاً, اذا كنت صاحب اسم العرض قم بتسحيل الدخول", color: "error"});
						}
						else if(err.response.data.errors.email && err.response.data.errors.email[0] == "The email has already been taken.") {
							this.$store.dispatch("notify", {message: "البريد الإلكتروني مأخوذ مسبقاً, اذا كنت صاحب البريد الإلكتروني قم بتسحيل الدخول", color: "error"});
						}
						else if(err.response.data.errors.phoneNumber && err.response.data.errors.phoneNumber[0] == "The phone number has already been taken.") {
							this.$store.dispatch("notify", {message: "رقم الجوال مأخوذ مسبقاً, اذا كنت صاحب رقم الجوال قم بتسحيل الدخول", color: "error"});
						}  else {
							this.$store.dispatch("notify", {message: "تعذر إضافة المستخدم", color: "error"});
						}
					} else {
						this.$store.dispatch("notify", {message: "تعذر إضافة المستخدم", color: "error"});
					}
					this.error = true;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		insertAdmin() {
			this.loading = true;
			var data = new FormData();
			data.append("userGroupID", this.$route.params.groupID);
			data.append("userID", this.newAdmin.userID);
			data.append("superAdmin", this.newAdmin.superAdmin || 0);

			clientNotifier
				.post("/api/usergroups/NewAdmin", data)
				.then(response => {
					console.log(response);
					this.addAdminDialog = false;
					this.getAdmins(this.adminsPage);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				})
		},
		updateAdmin() {
			this.loading = true;
			var data = new FormData();
			data.append("userGroupID", this.$route.params.groupID);
			data.append("userID", this.newAdmin.userID);
			data.append("superAdmin", this.newAdmin.superAdmin || 0);

			clientNotifier
				.post("/api/usergroups/updateAdmin", data)
				.then(response => {
					console.log(response);
					this.editAdminDialog = false;
					this.getAdmins(this.adminsPage);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				})
		},
		async confirmDeleteAdmin(userID) {
			const confirmed = await this.$refs.confirm.open({ title: "تأكيد الحذف",  message: "هل تريد حقاً حذف هذا المشرف" });
			if (confirmed) { this.deleteAdmin(userID); }
		},
		deleteAdmin(userID) {
			this.loading = true;
			const data = {
				userGroupID: this.$route.params.groupID,
				userID: userID,
			}
			clientNotifier
				.post("/api/usergroups/removeGroupAdmin", data)
				.then(response => {
					console.log(response);
					this.getAdmins(this.adminsPage);
				})
				.catch(err => {
					console.log(err);
				})
				.finally((() => {
					this.loading = false;
				}))
		},
		getSpecialties() {
			client
				.get("/api/specialties/all")
				.then(response => {
					this.allSpecialties = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
	}
};
</script>